import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import ErrorModal from '../Elements/ErrorModal'
import { Button, ButtonProps } from '@vtex/admin-ui'

export type BuyButtonProps = {
  skuId: string
  available: boolean
  withoutStock: boolean
  handleClick?: () => void
  isLoading: boolean
  isOnline?: boolean
} & ButtonProps

export const BuyButton = ({
  skuId,
  available,
  withoutStock,
  handleClick,
  isLoading,
  isOnline = true,
  children,
  ...props
}: BuyButtonProps) => {
  const [withoutStockOpen, setWithoutStockOpen] = useState(false)

  const handleAddToCart = () => {
    if (withoutStock) {
      setWithoutStockOpen(true)
    } else {
      handleClick?.()
    }
  }

  const handleBuyWithoutStockCancel = () => {
    setWithoutStockOpen(false)
  }

  const handleBuyWithoutStockContinue = () => {
    handleClick?.()
    setWithoutStockOpen(false)
  }

  const hasSelectedSku = !!skuId

  if (hasSelectedSku && !available && !isLoading) {
    return (
      <Button disabled id="product-page-add-to-cart-unavailable">
        <FormattedMessage id="productUnavailableFooterLabel" />
      </Button>
    )
  }

  return (
    <>
      <Button
        onClick={handleAddToCart}
        id={'product-page-add-to-cart'}
        disabled={!hasSelectedSku || isLoading || !isOnline}
        {...props}
      >
        {children}
      </Button>
      <ErrorModal
        errorIntl="withoutStock"
        onContinue={handleBuyWithoutStockContinue}
        onCancel={handleBuyWithoutStockCancel}
        isOpen={withoutStockOpen}
        confirmButtonDataCy="force-in-hands-confirm-button"
        cancelButtonDataCy="force-in-hands-cancel-button"
      />
    </>
  )
}
